import { createTRPCClient, httpBatchLink } from "@trpc/client";
import type { RentalsMerchantPortalRouter } from "@src/backend/src/rentals/functions/merchantsPortal";

export const onboardingClient = createTRPCClient<RentalsMerchantPortalRouter>({
  links: [
    httpBatchLink({
      maxItems: 5,
      url: import.meta.env.VITE_TRPC_API_URL,
    }),
  ],
});
